<template>
    <div class="bg-White">
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover; color: #fff;background: #007cef;">
    
            <CCol sm="12" lg="12" style="width: 80%;background-size: cover; margin: auto;color: #fff">
                <br /><br />
                <CRow>
                    <CCol sm="3" class="mt-5">
                        <div style="max-height: 400px; overflow: hidden;" class="b-20">
                        <video controls loop style="max-width: 100%" :src="video2" data-aos="zoom-in-down" :options="playerOptions" :autoplay="false"></video>
                    </div>
                    </CCol>
                    <CCol sm="3" class="mt-5"> 
                        <div style="max-height: 400px; overflow: hidden;" class="b-20"><video controls loop style="max-width: 100%" :src="video" data-aos="zoom-in-down" :options="playerOptions" :autoplay="false"></video></div></CCol>
                    <CCol sm="3" class="mt-5">   <div style="max-height: 400px; overflow: hidden;" class="b-20"><video controls loop style="max-width: 100%" :src="video3" data-aos="zoom-in-down" :options="playerOptions" :autoplay="false"></video></div></CCol>
                    <CCol sm="3" class="mt-5">   <div style="max-height: 400px; overflow: hidden;" class="b-20"><video controls loop style="max-width: 100%" :src="video1" data-aos="zoom-in-down" :options="playerOptions" :autoplay="false"></video></div></CCol>
    
    
                    <CCol sm="8" lg="8">
                        <div class="mt-4">
                            <h3 class="mt-2 custom-header-learnig">Bengkel Kuasai Sifir Tanpa Hafal Dalam 10 Minit & Kuasai Ucapan Spontan (Public Speaking) Dalam Bahasa Melayu.</h3>
                            <CRow>
                                <CCol sm="12">
    
                                    <div>
                                        <img style="width:24px;height:24px" src="../assets/img/staryellow.png" class="mr-2" />
                                        <img style="width:24px;height:24px" src="../assets/img/staryellow.png" class="mr-2" />
                                        <img style="width:24px;height:24px" src="../assets/img/staryellow.png" class="mr-2" />
                                        <img style="width:24px;height:24px" src="../assets/img/staryellow.png" class="mr-2" />
                                        <img style="width:24px;height:24px" src="../assets/img/staryellow.png" class="mr-2" /> (7) | <label class="custom-16px">Beginner</label> | <label class="custom-16px custom-border-light ml-3">Public Speaking</label>                                    | <label class="custom-16px custom-border-light ml-3">Matematik</label>
                                    </div>
    
                                </CCol>
                                <CCol sm="6" class="mt-5">
                                    <h5 class="custom-dollar mt-3">
                                        RM200 <img style="width:16px" src="../assets/img/timer.png" /> <label class="custom-14px-500">Original Price</label>
                                    </h5>
                                    <br />
                                    <CButton class="custom-card-learning text-white mb-4" style="height:55px;border-radius: 55px;font-size:20px" @click="GoToWhatsap()"><img style="width:24px" src="../assets/img/bgwhatsap.png" /> Contact US</CButton>
                                    <br />
                                </CCol>
                                <CCol sm="6" class="mt-5">
                                    <div class="mt-2">
                                        <CButton class="button-light-blue button-text"><img style="width:24px" src="../assets/img/bookmark.png" /> Design</CButton>
                                        <CButton class="button-light-blue button-text ml-2"><img style="width:24px" src="../assets/img/share1.png" /> Share</CButton>
                                    </div>
                                </CCol>
                            </CRow>
                        </div>
                    </CCol>
                    <CCol sm="4" lg="4">
                        <CCard class="custom-card-learning mt-3">
                            <h3 class="text-center custom-price mt-2">RM 99.00</h3>
                            <h3 class="text-center custom-price-sub mt-2">Highlights</h3>
                            <ul class="">
                                <li class="custom-li-price mt-3">Kuasai Sifir - Darab & Bahagi</li>
                                <li class="custom-li-price mt-3">Teknik Ucapan Spontan</li>
                                <li class="custom-li-price mt-3">Tips Menjadi Pembicara Versatile</li>
                            </ul>
                            <CButton class="button-price m-2 custom-bold-button" @click="GoToPayment()">Pay Now</CButton>
                        </CCard>
                    </CCol>
    
    
    
    
    
                </CRow>
            </CCol>
        </CCol>
    
        <CCol sm="12" class="bg-white">
    
            <CCol sm="12" style="width: 80%;background-size: cover; margin: auto;color: #fff">
                <CRow>
                    <CCol sm="7">
                        <CTabs variant="pills" horizontal class="mt-5">
                            <CTab active>
                                <template slot="title">
                                                               <label>Information</label>
</template>

<br /><br />
<h3 class="custom-label text-left"><img style="max-width:20px" src="../assets/img/location1.png" class="mr-2"/> Kuala Lumpur | <img style="max-width:20px" src="../assets/img/earth.png" class="mr-2"/> English, Melayu Malaysia
             |  <img style="max-width:20px" src="../assets/img/user.png" class="mr-2"/>217,869 pelajar
</h3>  
           
                <h3 class="custom-header-text mt-2">Bengkel Kuasai Sifir Tanpa Hafal Dalam 10 Minit</h3>
                <p class="custom-sub-text">
                Kelas ini bertujuan untuk membantu pelajar memperoleh 
                kecekapan dalam operasi matematik asas tanpa mengandalkan 
                hafalan terutama didalam bab sifir, darab dan bahagi. 
                Dalam kelas ini, teknik-teknik pengiraan pantas diajar 
                untuk mempercepatkan proses pengiraan dan meningkatkan 
                kefahaman terhadap konsep matematik. 
                
                Dengan menyertai kelas ini, pelajar akan dapat meningkatkan 
                kefahaman dan keyakinan mereka dalam matematik, serta memperoleh 
                kemahiran penting yang dapat membantu mereka dalam kehidupan seharian.</p>
                
                <h3 class="custom-header-text mt-5">Bengkel Kuasai Ucapan Spontan (Public Speaking) Dalam Bahasa Melayu.</h3>
                <p class="custom-sub-text">Kelas ini dirancang untuk membantu peserta mengembangkan kemahiran berkomunikasi 
                secara efektif dalam situasi awam. Peserta akan dipandu melalui pelbagai teknik 
                untuk mengatasi ketakutan berucap di hadapan orang ramai, merancang dan menyusun 
                ucapan yang padu, serta memperbaiki gaya pengucapan dan intonasi dalam Bahasa Melayu. 
                Melalui latihan dan bimbingan yang berterusan, peserta akan memperoleh keyakinan dan 
                kefasihan yang diperlukan untuk memberikan ucapan yang berkesan dan memukau. 
                Kelas ini memberi penekanan pada penguasaan bahasa dan kemahiran komunikasi yang 
                penting dalam kehidupan profesional dan sosial.</p>

<p class="custom-sub-400">Bengkel Kuasai Sifir tanpa hafal dalam 10 minit.<br />
BONUS! Boleh belajar teknik ucapan spontan (Public Speaking) juga di bengkel ni 😍 </p>
<p class="mt-3 custom-sub-400">Pickiddo menganjurkan bengkel yang berbentuk santai dan menyeronokkan dalam bilik dan suasana kampus!</p><br /><br />
<p class="mt-1 custom-sub-400">
🗓 Tarikh : 09 Mac 2024 <br />
📆 Hari & Masa : Sabtu, 10 am - 5 pm<br />
👶 Umur : 9 - 12 tahun (Darjah 3 - Darjah 6)<br />
🌲 Tempat : UKM Bangi<br />
💰 Yuran seorang: RM99<br />
➡️ Program termasuk Kit Bengkel, Sijil Penyertaan & makan dan minum.<br />
➡️ Hadiah misteri bagi pemenang permainan yang disediakan.<br />
<br /><br />
Apa yang anak dapat jika sertai bengkel kami<br />
⭐️ Kuasai sifir dengan CEPAT dan MUDAH tanpa tekanan.<br />
⭐️ Mengetahui tahap penguasaan matematik asas anak2 anda.<br />
⭐️ Kemahiran yang boleh dikongsi dengan rakan-rakan lain.<br />
⭐️ Menguasai teknik ucapan spontan (Public Speaking) dalam Bahasa Melayu.<br />
⭐️ Belajar kaedah meningkatkan keyakinan diri.<br />
⭐️ Jelajah kampus UKM.</p>

<p class="custom-18px-600">Tentatif. <br />
🕛 09.00 pagi - 10:00 pagi<br />
Pendaftaran Peserta & Makan Pagi<br /><br />

🕛 10.00 pagi - 11:00 pagi<br />
Sesi 1: Expert Sifir Hanya 10 minit<br /><br />

🕛 11:00 pagi - 12:00 tengahari<br />
Sesi 2: Expert Darab & Bahagi Hanya 10 minit<br /><br />

🕛 12:00 tengahari - 1:00 petang<br />
Sesi 3: Kuasai Ucapan Spontan (Public Speaking) Dalam Bahasa Melayu.<br /><br />

🕛1:00 petang - 2:00 petang<br />
Makan Tengah Hari dan Solat<br /><br />

🕛2:00 - 3:00 petang<br />
Sesi 4: Games<br /><br />

🕛3:00 - 3:30 petang<br />
Minum Petang<br /><br />

🕛3:30 - 4:00 petang<br />
Penyampaian Sijil & Hadiah<br /><br />

🕛 4:00 - 5:00 petang<br />
Tour Kampus & Bersurai</p>

              </CTab>
              <CTab>
<template slot="title">
     Review(12)
</template>

<h3 class="custom-rating"><img style="width:24px;height:24px" src="../assets/img/staryellow.png" class="mr-2" /> 4,5 Course Rating  - 17k rating</h3>
          <CRow class="mt-5">
            <CCol sm="2"><img src="../assets/img/us1.png" /></CCol>
            <CCol sm="10">
                <h3 class="custom-username">Normala Sari</h3>
                <img style="width:16px;height:16px" src="../assets/img/staryellow.png" class="mr-2" />
                <img style="width:16px;height:16px" src="../assets/img/staryellow.png" class="mr-2" />
                <img style="width:16px;height:16px" src="../assets/img/staryellow.png" class="mr-2" />
                <img style="width:16px;height:16px" src="../assets/img/staryellow.png" class="mr-2" />
                <img style="width:16px;height:16px" src="../assets/img/staryellow.png" class="mr-2" />
                <label class="custom-rate-number">5.0</label>
                <label class="custom-day">  | 10 day ago</label>
                <p class="custom-comment">Dari pengalaman sebelum ini, kelas seperti ini sangat membantu anak saya untuk focus dengan belajar matematik. cikgu yang mengajar sangat membantu.</p>
            </CCol>
          </CRow>  
          <CRow class="mt-5">
            <CCol sm="2"><img src="../assets/img/us2.png" /></CCol>
            <CCol sm="10">
                <h3 class="custom-username">Khadijah Hassan</h3>
                <img style="width:16px;height:16px" src="../assets/img/staryellow.png" class="mr-2" />
                <img style="width:16px;height:16px" src="../assets/img/staryellow.png" class="mr-2" />
                <img style="width:16px;height:16px" src="../assets/img/staryellow.png" class="mr-2" />
                <img style="width:16px;height:16px" src="../assets/img/staryellow.png" class="mr-2" />
                <img style="width:16px;height:16px" src="../assets/img/staryellow.png" class="mr-2" />
                <label class="custom-rate-number">5.0</label>
                <label class="custom-day">  | 1 day ago</label>
                <p class="custom-comment">Belajar teknik tanpa menghafal boleh menjadikan kanak2 ada perasaan ingin tahu. Itu satu bentuk pengetahuan yang boleh digunakan selain teknik menghafal</p>
            </CCol>
          </CRow>  
          <CRow class="mt-5">
            <CCol sm="2"><img src="../assets/img/us3.png" /></CCol>
            <CCol sm="10">
                <h3 class="custom-username">Kamis</h3>
                <img style="width:16px;height:16px" src="../assets/img/staryellow.png" class="mr-2" />
                <img style="width:16px;height:16px" src="../assets/img/staryellow.png" class="mr-2" />
                <img style="width:16px;height:16px" src="../assets/img/staryellow.png" class="mr-2" />
                <img style="width:16px;height:16px" src="../assets/img/staryellow.png" class="mr-2" />
                <img style="width:16px;height:16px" src="../assets/img/staryellow.png" class="mr-2" />
                <label class="custom-rate-number">5.0</label>
                <label class="custom-day">  | 10 day ago</label>
                <p class="custom-comment">Saya rasa mungkin waktu program perlu di bahagi kepada beberapa segment. segment games membantu anak saya minat dan dapat menarik dia untuk terus berada dalam bengkel..</p>
            </CCol>
          </CRow>  
          <CRow class="mt-5">
            <CCol sm="2"><img src="../assets/img/us4.png" /></CCol>
            <CCol sm="10">
                <h3 class="custom-username">Lee Seen Che</h3>
                <img style="width:16px;height:16px" src="../assets/img/staryellow.png" class="mr-2" />
                <img style="width:16px;height:16px" src="../assets/img/staryellow.png" class="mr-2" />
                <img style="width:16px;height:16px" src="../assets/img/staryellow.png" class="mr-2" />
                <img style="width:16px;height:16px" src="../assets/img/staryellow.png" class="mr-2" />
                <img style="width:16px;height:16px" src="../assets/img/staryellow.png" class="mr-2" />
                <label class="custom-rate-number">5.0</label>
                <label class="custom-day">  | 10 day ago</label>
                <p class="custom-comment">I hope we can do more similar like this but please put more effort for the games as well. kids enjoy the class.</p>
            </CCol>
          </CRow>  
<div class="text-center">
          <CButton class="custom-button-profile color-blue mb-5">View Review</CButton>
          </div>
        


</CTab>
            </CTabs>
                    </CCol>
                    <CCol sm="5">
                        <CCard class="custom-border-grey-card mt-5" style="border:none">
                            <div>
                          <h5 class="custom-20px-700 ml-3 mt-3">Rating</h5>
                          <CRow>
                            <CCol sm="3">
                                <div class="text-center">
                                <h3 class="custom-big-rate text-center mt-2">4.5</h3>
                                <img style="width:14px;height:14px" src="../assets/img/staryellow.png" />
                                <img style="width:14px;height:14px" src="../assets/img/staryellow.png" />
                                <img style="width:14px;height:14px" src="../assets/img/staryellow.png" />
                                <img style="width:14px;height:14px" src="../assets/img/staryellow.png" />
                                <p class="custom-12px-500">
                                    60 Reviews
                                </p>
                            </div>
                            </CCol>
                            <CCol sm="9">
                                <div>
                                <CCol sm="12">
                                <CRow>
                                    <CCol sm="1"><img style="width:16px;height:16px" src="../assets/img/staryellow.png" /></CCol>
                                    <CCol sm="1"><span class="custom-rate-bold">  5 </span> </CCol>
                                    <CCol sm="7"><img style="max-width:100%" src="../assets/img/p1.png"/></CCol>
                                    <CCol sm="2"><span class="custom-rate-bold">  100 </span> </CCol>
                                </CRow>
                                <CRow>
                                    <CCol sm="1"><img style="width:16px;height:16px" src="../assets/img/staryellow.png" /></CCol>
                                    <CCol sm="1"><span class="custom-rate-bold">  4 </span> </CCol>
                                    <CCol sm="7"><img style="max-width:100%" src="../assets/img/progress4.png"/></CCol>
                                    <CCol sm="2"><span class="custom-rate-bold">  44 </span> </CCol>
                                </CRow>
                                <CRow>
                                    <CCol sm="1"><img style="width:16px;height:16px" src="../assets/img/staryellow.png" /></CCol>
                                    <CCol sm="1"><span class="custom-rate-bold">  3 </span> </CCol>
                                    <CCol sm="7"><img style="max-width:100%" src="../assets/img/progress3.png"/></CCol>
                                    <CCol sm="2"><span class="custom-rate-bold">  7 </span> </CCol>
                                </CRow>
                                <CRow>
                                    <CCol sm="1"><img style="width:16px;height:16px" src="../assets/img/staryellow.png" /></CCol>
                                    <CCol sm="1"><span class="custom-rate-bold">  2 </span> </CCol>
                                    <CCol sm="7"><img style="max-width:100%" src="../assets/img/progress2.png"/></CCol>
                                    <CCol sm="2"><span class="custom-rate-bold">  0 </span> </CCol>
                                </CRow>
                                <CRow>
                                    <CCol sm="1"><img style="width:16px;height:16px" src="../assets/img/staryellow.png" /></CCol>
                                    <CCol sm="1"><span class="custom-rate-bold">  1 </span> </CCol>
                                    <CCol sm="7"><img style="max-width:100%" src="../assets/img/progress1.png"/></CCol>
                                    <CCol sm="2"><span class="custom-rate-bold">  0 </span> </CCol>
                                </CRow>
                            </CCol>
                            </div>
                              
                            </CCol>
                          </CRow>
                        </div>
                        </CCard>

                        <CCard class="custom-border-grey-card mt-2" style="border:none">
                            <div>
                          <h5 class="custom-20px-700 ml-3 mt-3">About Tutor</h5>
                          <CRow class="p-2">
                            <CCol sm="2"><img style="max-width:100%" src="../assets/img/userabout.png" /></CCol>
                            <CCol sm="5"><h3 class="custom-18px-600">Cikgu Ilmi</h3>
                                <p class="custom-12px-500 m-0">
                                    Professional Math Teacher
                                </p></CCol>
                            <CCol sm="5">
                                <CButton class="custom-button-profile color-blue">See Full Profile</CButton>
                            </CCol>
                    
                            </CRow>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                           
                            <CRow class="p-2">
                            <CCol sm="2"><img style="max-width:100%" src="../assets/img/userabout1.png" /></CCol>
                            <CCol sm="5"><h3 class="custom-18px-600">Ridhwan Salimi</h3>
                                <p class="custom-12px-500 m-0">
                                    Professional Public Speaking
                                </p></CCol>
                            <CCol sm="5">
                                <CButton class="custom-button-profile color-blue">See Full Profile</CButton>
                            </CCol>
                    
                            </CRow>
                            </div>
                        </CCard>
                    </CCol>
                </CRow>
    
            </CCol>

            <CCol sm="12" style="width: 80%;background-size: cover; margin: auto;color: #fff">
<CRow>
    <CCol sm="8">
       <h3 class="custom-48px mt-5"> Requirements</h3>
       <p class="custom-12px-500">
        Below are the requirement for this course
                                </p>
                                <CCard class="custom-border-grey-card mt-5 p-2" style="border:none">
                                    <h3 class="custom-16px-500">
                                        Berumur 9 hingga 12 tahun (Darjah 3 hingga 6)
                                    </h3>
                                    </CCard>

                                    <CCard class="custom-border-grey-card mt-2 p-2" style="border:none">
                                    <h3 class="custom-16px-500">
                                        Perlu membawa laptop / tablet / telefon bimbit (untuk penggunaan menjawab kuiz sewaktu permainan kuiz bermula)
                                    </h3>
                                    </CCard>

                                    <CCard class="custom-border-grey-card mt-2 p-2" style="border:none">
                                    <h3 class="custom-16px-500">
                                        Berpakaian sopan ketika menghadiri bengkel.
                                    </h3>
                                    </CCard>
    </CCol>
    <CCol sm="4">
        <br /> <br />
        <div class="mt-5">
        <img style="max-width:100%" src="../assets/img/child.png" />
    </div>
    </CCol>
</CRow>
</CCol>
</CCol>

<CCol sm="12" style="background-size: cover; color: #fff;background: #007cef;">
    <CCol sm="12" style="width: 80%;background-size: cover; margin: auto;color: #fff">
        <CRow>
            <CCol sm="4">
                <div class="mt-5">
                    <br /><br />
                <img style="max-width:100%" src="../assets/img/2user.png" />
            </div>
            </CCol>
            <CCol sm="8">
                <h1 class="custom-48px-white mt-5">
                    What you will learn
                </h1>
                <CCard class="custom-border-light-blue mt-3" style="border:none">
                    <CRow>
                        <CCol sm="6">
                            <div class="p-2">
                           <h3 class="custom-20px-500 ml-4 mt-4"><img style="max-width:20px" src="../assets/img/check.png" />Kuasai sifir dengan cepat dan mudah tanpa tekanan.</h3> 
                        </div>
                        </CCol>
                        <CCol sm="6">
                            <div class="p-1">
                           <h3 class="custom-20px-500 mt-4"><img style="max-width:20px" src="../assets/img/check.png" />Kuasai sifir dengan cepat dan mudah tanpa tekanan.</h3> 
                        </div>
                        </CCol>
                        <CCol sm="6">
                            <div class="p-1">
                           <h3 class="custom-20px-500 ml-4"><img style="max-width:20px" src="../assets/img/check.png" />Menambah pengetahuan baru bersama guru dan rakan-rakan.</h3> 
                        </div>
                        </CCol>
                        <CCol sm="6">
                            <div class="p-1">
                           <h3 class="custom-20px-500"><img style="max-width:20px" src="../assets/img/check.png" />Belajar dalam suasana kampus yang menyeronokkan.</h3> 
                        </div>
                        </CCol>
                        <CCol sm="6">
                            <div class="p-1">
                           <h3 class="custom-20px-500 ml-4"><img style="max-width:20px" src="../assets/img/check.png" />Kuasai teknik ucapan spontan.</h3> 
                        </div>
                        </CCol>
                        <CCol sm="6">
                            <div class="p-1">
                           <h3 class="custom-20px-500"><img style="max-width:20px" src="../assets/img/check.png" />Mendapat pendedahan dan pengalaman belajar di kampus.</h3> 
                        </div>
                        </CCol>
                    </CRow>
                    <br /><br />
                </CCard>
            </CCol>
        </CRow>
        <br /><br /><br />
    </CCol>
    </CCol>
    <CCol sm="12" class="bg-white">
    <CCol sm="12" style="width: 80%;background-size: cover; margin: auto;color: #fff">
<CRow>
       <h3 class="custom-48px mt-5"> Gallery</h3>
       <CRow class="mt-4">
        <CCol sm="3">
            <img style="max-width:100%" src="../assets/img/g1.png" />
        </CCol>
        <CCol sm="3"><img style="max-width:100%" src="../assets/img/g2.png" /></CCol>
        <CCol sm="3"><img style="max-width:100%" src="../assets/img/g3.png" /></CCol>
        <CCol sm="3"><img style="max-width:100%" src="../assets/img/g4.png" /></CCol>
       </CRow>

       </CRow>
       </CCol>
       </CCol>

       <CCol sm="12" class="bg-white">
    <CCol sm="12" style="width: 80%;background-size: cover; margin: auto;color: #fff">
<CRow>
       <h3 class="custom-48px mt-5"> Recommendation</h3>
       <CRow class="mt-4 mb-5">
        <CCol sm="3">
            <img style="max-width:100%" src="../assets/img/t1.png" />
        </CCol>
        <CCol sm="3"><img style="max-width:100%" src="../assets/img/t2.png" /></CCol>
        <CCol sm="3"><img style="max-width:100%" src="../assets/img/t3.png" /></CCol>
        <CCol sm="3"><img style="max-width:100%" src="../assets/img/t4.png" /></CCol>
       </CRow>

       </CRow>
       </CCol>
       </CCol>
    
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import video from "../assets/img/v1.mp4";
import video1 from "../assets/img/v2.mp4";
import video2 from "../assets/img/v3.mp4";
import video3 from "../assets/img/v4.mp4";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            video,
            video1,
            video2,
            video3


        };
    },
    created() {
        AOS.init();
    },

    methods: {
        GoToPayment()
        {
            window.open("https://www.billplz.com/fastmathsxpickiddo");
        },
        GoToWhatsap()
        {
            window.open("https://wa.me/60106597700?text=Hello%20,%20I%20want%20to%20know%20about%20:BengkelSifir");
        }
    }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat');
body {
    top: 0 !important;
    font-family: 'Montserrat', sans-serif;
}

.custom-tab .nav-link.active {
    border-bottom: 2px solid #000;
    /* Replace with your desired border color */
}
</style>